export default {
  product: {
    name: 'Acheter une carte cadeau',
  },
  description: {
    items: {
      delivery: 'Envoyé immédiatement par e-mail en PDF',
      usage: {
        online: 'Utilisable en ligne uniquement',
        online_and_store: 'Utilisable en ligne et au restaurant',
      },
      value: 'Montants flexibles de {{from}} à {{to}}',
    },
  },
};
